<div class="component-container" style="height: 100%; margin-top: 2rem">
  <div class="well" style="height: 100%; width: 100%">
    <div class="row" style="height: 100%">
      <div
        style="
          height: 100%;
          padding-bottom: 10px;
          float: left;
          position: relative;
          min-height: 1px;
          padding-left: 15px;
          padding-right: 15px;
          width: 100%;
        "
      >
        <div
          class="panel panel-info"
          style="height: 100%; display: flex; flex-direction: column"
        >
          <div
            class="panel-heading"
            style="display: flex; justify-content: flex-start; gap: 7rem"
          >
            <h3
              style="
                justify-content: center;
                align-items: center;
                align-content: center;
                align-self: center;
                margin-top: 0;
              "
            >
              Custom Analytics Dashboard
            </h3>
            <div class="form-group input-group has-feedback">
              <h4>Time Period:</h4>
              <select
                id="selectTimePeriod"
                name="selectTimePeriod"
                [(ngModel)]="selectedTimePeriod"
                (ngModelChange)="onDateChange()"
                class="form-control"
              >
                <option
                  *ngFor="let period of timePeriods"
                  [value]="period.value"
                >
                  {{ period.display }}
                </option>
              </select>
            </div>
            <div class="form-group input-group has-feedback">
              <h4>Start:</h4>
              <input
                type="text"
                [bsConfig]="bsConfig"
                class="form-control"
                placeholder="Select date"
                bsDatepicker
                [(ngModel)]="selectedStartDate"
                (ngModelChange)="onDateChange()"
              />
            </div>
            <div class="form-group input-group has-feedback">
              <h4>End:</h4>
              <input
                type="text"
                [bsConfig]="bsConfig"
                class="form-control"
                placeholder="Select date"
                bsDatepicker
                [(ngModel)]="selectedEndDate"
                (ngModelChange)="onDateChange()"
              />
            </div>
            <a
              (click)="refresh()"
              class="cursor-pointer"
              style="
                justify-content: center;
                align-items: center;
                align-content: center;
                align-self: center;
                margin-top: 0;
              "
            >
              <i class="fa fa-fw fa-solid fa-rotate-right" title="Refresh"></i>
              <span>Refresh</span>
            </a>
            <div
              *ngIf="exportOptions.length > 0"
              class="pull-right"
              style="
                margin-left: 15px;
                margin-right: 3em;
                justify-content: center;
                align-items: center;
                align-content: center;
                margin-top: 0;
              "
            >
              <div
                *ngIf="exporting"
                style="display: inline-block; margin-right: 10px"
              >
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              <div *ngIf="!exporting" class="dropdown">
                <a href="" class="dropdown-toggle" data-toggle="dropdown">
                  <span>Export All</span>
                  <b class="caret"></b>
                </a>
                <ul class="dropdown-menu">
                  <ng-container>
                    <li *ngFor="let exportType of exportAllTypes">
                      <button
                        (click)="onExportAllClick($event, exportType)"
                        [matTooltip]="exportType === 'PDF' ? shouldEnableExportAllToPDF ? 'Will only include charts that can be exported to PDF.' : 'No charts can be exported as PDFs.' : ''"
                        matTooltipClass="export-tooltip"
                        matTooltipPosition="left"
                        [disabled]="exportType === 'PDF' && !shouldEnableExportAllToPDF"
                        class="add-chart-btn-popup"
                      >
                        <span>{{ exportType }}</span>
                      </button>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
          <div
            #dashboardDesigner
            class="panel-body"
            style="
              flex-grow: 1;
              height: 100%;
              overflow-y: auto;
              overflow-x: hidden;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <div style="width: 100%" *ngIf="dashboardData.rows.length !== 0">
                <div
                  style="width: 100%"
                  *ngFor="let row of dashboardData.rows; let rowIndex = index"
                >
                  <div class="chart-container-row">
                    <ng-container
                      *ngFor="let tile of row.tiles; let i = index; let last = last"
                    >
                      <div
                        class="chart-container-tile"
                        [ngClass]="{
    'focused-chart': focusedTile?.rowIndex === rowIndex && focusedTile?.tileIndex === i
  }"
                      >
                        <button
                          (click)="openChartDialog($event, i, rowIndex)"
                          *ngIf="!tile.chart"
                          class="tile"
                        >
                          Add Chart
                        </button>
                        <ng-container
                          *ngIf="tile.chart"
                          style="position: relative"
                        >
                          <div class="chart-button-container">
                            <div
                              class="cursor-pointer chart-button"
                              (click)="openExportDialog($event, i, rowIndex)"
                            >
                              <i
                                class="fa fa-fw fa-solid fa-download"
                                title="Export"
                              ></i>
                            </div>
                            <a
                              [routerLink]="['/analytics/chartdetails', tile.chart]"
                              class="cursor-pointer chart-button"
                              style="color: inherit"
                            >
                              <i
                                class="fa fa-fw fa-list-alt"
                                title="Go To Details"
                              ></i>
                            </a>
                            <div
                              class="cursor-pointer chart-button"
                              (click)="openChartDialog($event, i, rowIndex)"
                            >
                              <i
                                class="fa fa-fw fa-solid fa-refresh"
                                title="Swap"
                              ></i>
                            </div>
                            <div
                              class="cursor-pointer chart-button"
                              (click)="deleteTile($event, rowIndex, i)"
                            >
                              <i
                                class="fa fa-fw fa-solid fa-trash"
                                title="Delete Chart"
                              ></i>
                            </div>
                          </div>
                          <dynamic-analytics-chart
                            class="dynamic-chart"
                            [startDate]="selectedStartDate"
                            [endDate]="selectedEndDate"
                            style="width: 100%; height: 100%; overflow: auto"
                            [chartType]="tile.chart"
                          >
                          </dynamic-analytics-chart>
                          <!-- The version of selecting the chart below works, but the chart does not display -->
                          <!-- <ng-container style="width: 100%; height: 100%;" *ngComponentOutlet="chartTypes[tile.chart].chartComponent; injector: dynamicInjector"></ng-container> -->
                          <div
                            class="chart-overlay"
                            (click)="focusChart(rowIndex, i)"
                            *ngIf="!(focusedTile?.rowIndex === rowIndex && focusedTile?.tileIndex === i)"
                            [ngClass]="{
                                      'overlay-dimmed': focusedTile !== null
                                    }"
                          ></div>
                        </ng-container>
                      </div>
                      <div
                        *ngIf="!last && !(focusedTile?.rowIndex === rowIndex && focusedTile?.tileIndex === i)"
                      >
                        <hr
                          style="
                            height: 100%;
                            border: none;
                            border-left: 1px solid rgb(238, 238, 238);
                            margin: 0 10px;
                          "
                        />
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="row.tiles.length === 0 || row.isEmpty()"
                    >
                      <div
                        class="cursor-pointer"
                        (click)="deleteRow($event, rowIndex)"
                        style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          width: 3rem;
                          height: 3rem;
                        "
                      >
                        <i
                          class="fa fa-fw fa-trash"
                          aria-hidden="true"
                          title="Delete Row"
                        ></i>
                      </div>
                    </ng-container>
                  </div>
                  <hr />
                </div>
              </div>

              <!-- Fallback if no rows exist -->
              <ng-content *ngIf="!isLoadingConfig">
                <div
                  class="text-center"
                  *ngIf="dashboardData.rows.length === 0"
                >
                  <p>To begin, start adding rows to the dashboard.</p>
                  <p>You can select what charts will appear in which tiles.</p>
                  <p>Your custom dashboard will persist between logins.</p>
                </div>
                <button
                  (click)="addRow()"
                  style="margin-top: 3rem; margin-bottom: 3rem"
                  class="add-row-btn"
                >
                  Add Row
                </button>
              </ng-content>
              <ng-content *ngIf="isLoadingConfig">
                <div class="spinner-container" style="margin-top: 7rem">
                  <div class="spinner"></div>
                </div>
                <div>Loading Configuration...</div>
              </ng-content>
            </div>
            <div
              style="
                position: fixed;
                display: none;
                max-height: 275px;
                overflow-y: auto;
              "
              #hoverPopup
              class="popup"
              [style.top.px]="popupTop"
              [style.left.px]="popupLeft"
            >
              <!-- <div *ngFor="let type of chartTypes">
                                <button (click)="selectChart(type)" class="add-chart-btn-popup">{{ type }}</button>
                            </div> -->
              <div *ngFor="let chartSection of filteredAndSortedChartTypes">
                <span class="chart-nav-header"
                  >{{chartSection.type.toString()}}</span
                >
                <div *ngFor="let entry of chartSection.charts">
                  <button
                    (click)="onSelectChart($event, entry.key)"
                    class="add-chart-btn-popup"
                  >
                    <span>{{ entry.section.title }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div
              style="
                position: fixed;
                display: none;
                max-height: 275px;
                overflow-y: auto;
              "
              #hoverPopupForExport
              class="popup"
              [style.top.px]="popupTop"
              [style.left.px]="popupLeft"
            >
              <div *ngFor="let exportOption of chartOptionsForExport">
                <button
                  (click)="onSelectChartForExport($event, chartSelectedForExport.title, exportOption)"
                  class="add-chart-btn-popup"
                >
                  {{exportOption}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
